export default __webpack_public_path__ + "static/media/arrow.474f4ea1.svg";